import React, { Component } from 'react';
import _ from 'lodash';

import RadioChecked from 'icons/RadioChecked';
import RadioUnChecked from 'icons/RadioUnChecked';
import './RadioGroup.scss';

class RadioGroup extends Component {
  onCheck = (value) => {
    this.props.onCheck(value);
  }

  render() {
    return (
      <div className="radio-group">
        {
          _.map(this.props.items, (item) => {
            return (
              <div className="radio" key={item.label} onClick={() => this.onCheck(item.value)}>
                { this.props.value === item.value &&
                  <RadioChecked />
                }
                { this.props.value !== item.value &&
                  <RadioUnChecked />
                }
                <div>
                  {item.label}
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default RadioGroup;
